import Image from "next/image";

import type { AppLocale } from "@/config/app-locale";
import { tenantLogoFor } from "@/config/tenant-assets";
import type { TenantCode } from "@/config/tenants";

interface TenantLogoProps {
  className?: string;
  locale: AppLocale;
  priority?: boolean;
  tenant: TenantCode;
}

export function TenantLogo({ className, locale, priority = false, tenant }: Readonly<TenantLogoProps>) {
  const logo = tenantLogoFor(tenant, locale);

  if (!logo) {
    return null;
  }

  return (
    <Image
      alt={logo.alt}
      className={className}
      height={320}
      priority={priority}
      src={logo.src}
      width={320}
    />
  );
}
